import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Collection } from '../../../graphql/generated/generated-types';
import { Observable } from 'rxjs';
import { RouterLink } from '@angular/router';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';



@Component({
  selector: 'app-parts-catalog-navigation-menu',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './parts-catalog-navigation-menu.component.html',
  styleUrl: './parts-catalog-navigation-menu.component.scss'
})
export class PartsCatalogNavigationMenuComponent {
  @Input() collection$!: Observable<Collection | undefined>;

  constructor(public vehicleTypeService: VehicleTypeService, public selectedModificationService: SelectedModificationService) {}


  public getCollectionIsSlug(collection: Collection){
    const isSlugTranslation = collection?.translations?.find(
      (item) => item.languageCode === 'is'
    );
  
    if (isSlugTranslation) {
      return isSlugTranslation.slug
    } else {
      return collection.slug
    }   
}
}
